import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTransactionList } from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import {
  CLIENT,
  SUCCESS,
  TRANSACTION_CREDITED,
  TRANSACTION_DEBITED,
  TRANSACTION_DEEMED,
  TRANSACTION_FAIL,
  TRANSACTION_FAILED,
  TRANSACTION_PENDING,
  TRANSACTION_REFUND,
  TRASACTION_FAILURE,
} from "../../../../utility/constants/valueConstants";
import { formatBalance } from "../../../../utility/moneyFormatter";
import { voucherTransactionHeaders } from "../../../../utility/TableHeaders";
import CustomModal from "../../../components/main_comps/custom_modal";
import { CustomViewModal } from "../../../components/main_comps/custom_modal/CustomViewModal";
import CustomTable from "../../../components/main_comps/custom_table";

const VoucherTransaction = ({ currentTab, selectedService }) => {
  const dispatch = useDispatch();
  const transaction = useSelector(
    (state) => state.listingSlice.voucherTransactionList
  );
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const [currentPage, setCurrentPage] = useState(0);
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [viewMoreData, setViewMoreData] = useState({});
  const [dataForModal, setDataForModal] = useState({});
  const filters = useSelector((state) => state.globalFiltersSlice);
  // console.log(filters, "FILTERS_VOUCHER");

  const [clientDetails, setClientDetials] = useState({});

  const getClientProgram = () => {
    let voucher = clientSecret.filter((obj) => obj.serviceType === "voucher");
    if (voucher.length > 0) {
      setClientDetials(voucher[0]);
    }
  };
  const role = secureStorage.getItem(SS_ROLE);

  useEffect(() => {
    let data1 = {
      "Reseller Name": role === CLIENT ? "N/A" : viewMoreData?.reseller_name,
    };
    let data = {
      "Date & Time:": moment(viewMoreData?.created_at).format(
        "DD/MM/YYYY HH:mm A"
      ),
      "Client Name": viewMoreData?.client_name,

      "Customer Name": viewMoreData?.customerName ?? "N/A",
      "Customer UPI": viewMoreData?.upi_id ?? "N/A",
      "Transaction type:":
        viewMoreData?.transferType ?? viewMoreData?.service_type,
      "Actual Amount":
        "Rs " + formatBalance(Number(viewMoreData?.actual_amount)),
      Commission:
        viewMoreData["status"] === TRANSACTION_CREDITED ||
        viewMoreData["status"] === SUCCESS ||
        viewMoreData["status"] === TRANSACTION_DEBITED ||
        viewMoreData["status"] === TRANSACTION_DEEMED
          ? "Rs " + formatBalance(Number(viewMoreData?.commissionAmount))
          : "Rs 0",
      "Commission Gst":
        viewMoreData["status"] === TRANSACTION_CREDITED ||
        viewMoreData["status"] === SUCCESS ||
        viewMoreData["status"] === TRANSACTION_DEBITED ||
        viewMoreData["status"] === TRANSACTION_DEEMED
          ? "Rs " + formatBalance(Number(viewMoreData?.commissionGst))
          : "Rs 0",

      "Final Amount":
        viewMoreData["status"] === TRANSACTION_CREDITED ||
        viewMoreData["status"] === SUCCESS ||
        viewMoreData["status"] === TRANSACTION_DEBITED ||
        viewMoreData["status"] === TRANSACTION_DEEMED
          ? "Rs " + formatBalance(Number(viewMoreData?.final_amount))
          : "Rs " + formatBalance(Number(viewMoreData?.actual_amount)),
      "Upi Txn Id": viewMoreData?.upi_txn_id ?? "N/A",
      "Bank Utr:": viewMoreData?.transferUniqueNo
        ? viewMoreData?.transferUniqueNo
        : viewMoreData?.custRefNo ?? "N/A",
      "Txn id:": viewMoreData?.transactionId ?? "N/A",

      Status:
        viewMoreData?.status === TRANSACTION_CREDITED ||
        viewMoreData?.status === SUCCESS ||
        viewMoreData?.status === TRANSACTION_DEBITED ||
        viewMoreData?.status === TRANSACTION_REFUND
          ? "Success"
          : viewMoreData?.status === TRANSACTION_FAILED ||
            viewMoreData?.status === TRANSACTION_FAIL ||
            viewMoreData?.status === TRASACTION_FAILURE
          ? "Failed"
          : viewMoreData?.status === TRANSACTION_PENDING
          ? "Initiated"
          : viewMoreData?.status === TRANSACTION_DEEMED
          ? "Deemed"
          : "",
      "Modified Date": moment(viewMoreData?.modified_at).format(
        "DD/MM/YYYY HH:mm A"
      ),
    };

    if (role === CLIENT) {
      setDataForModal(data);
    } else {
      setDataForModal({ ...data, ...data1 });
    }
  }, [viewMoreData]);

  const setHeaders = (data, role, acl) => {
    let arr = [];

    data &&
      data?.map((val, i) => {
        if (val?.roles || val?.acl) {
          if (val?.roles?.includes(role) || acl?.includes(val?.acl))
            arr.push({
              title: val?.title,
              key: val?.key,
            });
        } else {
          arr.push({
            title: val?.title,
            key: val?.key,
          });
        }
      });
    return arr;
  };

  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 15);
  const defaultDateRange = `${("0" + startDate.getDate()).slice(-2)}/${(
    "0" +
    (startDate.getMonth() + 1)
  ).slice(-2)}/${startDate.getFullYear()}-${("0" + endDate.getDate()).slice(
    -2
  )}/${("0" + (endDate.getMonth() + 1)).slice(-2)}/${endDate.getFullYear()}`;

  useEffect(() => {
    dispatch(
      fetchTransactionList({
        dateRange:
          filters?.fromDate && filters?.toDate
            ? moment(filters?.fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(filters?.toDate).format("DD/MM/YYYY")
            : defaultDateRange,
        page: 0,
        size: 10,
        resellerId: filters?.resellerId?.value,
        clientId: filters?.clientId?.value,
        status: filters?.status
          ? filters?.status.value
          : currentTab === 5
          ? filters?.status.value
          : "",
        serviceType: "voucher",
        rootReferenceId: "",
        custRefNo: filters?.custRefNo ?? "",
        transactionId: filters?.transactionId ?? "",
        serviceProviderName: "neokred",
        mechanism: "",
      })
    );
  }, []);

  useEffect(() => {
    if (role === CLIENT) {
      getClientProgram();
    }
  }, []);

  return (
    <div style={styles.maindiv}>
      <div style={styles.tablestyle}>
        <CustomTable
          data={transaction?.transactions}
          currentPage={transaction?.currentPageNo - 1}
          headers={setHeaders(voucherTransactionHeaders, role)}
          totalElements={transaction?.totalRecords}
          totalPages={transaction?.totalPages}
          handlePaginate={(page) => {
            console.log(page, "PAGE");
            setCurrentPage(page);
            dispatch(
              fetchTransactionList({
                dateRange:
                  filters?.fromDate && filters?.toDate
                    ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(filters?.toDate).format("DD/MM/YYYY")
                    : defaultDateRange,
                page: page + 1,
                size: 10,
                resellerId: filters?.resellerId?.value,
                serviceType: "voucher",
                serviceProviderName: "neokred",
                clientId: filters?.clientId?.value,
                status: filters?.status ? filters?.status.value : "",
                custRefNo: filters?.custRefNo ?? "",
                transactionId: filters?.transactionId ?? "",
                mechanism: "",
              })
            );
          }}
          onViewMore={(row) => {
            setViewMoreModal(true);
            setViewMoreData(row);
          }}
          emptyDataMessage="No transaction found."
        />

        {viewMoreModal && (
          <CustomModal
            open={viewMoreModal}
            onClose={() => {
              setViewMoreModal(false);
              // setDataForModal({});
            }}
            containerStyle={{
              minWidth: 350,
              maxWidth: 450,
              height: "100%",
              borderRadius: "20px 0px 0px 20px",
            }}
            viewMoreStyle={{
              justifyContent: "flex-end",
            }}
            isHeaderRequired={false}
          >
            <CustomViewModal
              data={dataForModal}
              closeModal={() => {
                setViewMoreModal(false);
                // setDataForModal({});
              }}
            />
          </CustomModal>
        )}
      </div>
    </div>
  );
};
const styles = {
  maindiv: {
    backgroundColor: "#FFFFFF",
    paddingTop: "20px",
    paddingLeft: "20px",
  },
  tablestyle: {
    overflow: "hidden",
  },
};
export default VoucherTransaction;
